import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuButton, NeuCard, NeuInput } from "../../components/neu/Neu";
import { disposeAsset } from "../../api/accounting";
import { impairAsset } from "../../api/acctIfrs";
import { useApiError } from "../../hooks/useApiError";

export const AssetRow = ({ row, onDone }) => {
  const { t } = useTranslation();
  const describe = useApiError();
  const [amount, setAmount] = useState("");
  const [open, setOpen] = useState(false);

  const impair = async () => {
    try {
      const res = await impairAsset(row.id, { amount: Number(amount) });
      toast.success(`${t("acct.ifrs.impaired")} ${res.entry_number}`);
      setAmount("");
      setOpen(false);
      onDone();
    } catch (error) {
      toast.error(describe(error));
    }
  };

  return (
    <NeuCard className="grid gap-3 p-4" data-testid={`asset-row-${row.id}`}>
      <div className="flex flex-wrap items-center gap-3">
        <span className="min-w-0 flex-1 truncate text-sm font-bold">{row.name}</span>
        <span className="font-mono text-xs" dir="ltr">{row.cost}</span>
        <span className="font-mono text-xs text-muted-foreground" dir="ltr">{row.accumulated_depreciation}</span>
        <span className="font-mono text-sm font-bold" dir="ltr">{row.book_value}</span>
        <span className="text-[11px] font-bold">{t(`acct.assetStatus.${row.status}`)}</span>
        {row.status !== "disposed" ? (
          <>
            <NeuButton className="px-3 py-2 text-xs" data-testid={`asset-impair-${row.id}`} onClick={() => setOpen(!open)}>
              {t("acct.ifrs.impair")}
            </NeuButton>
            <NeuButton
              variant="danger"
              className="px-3 py-2 text-xs"
              data-testid={`asset-dispose-${row.id}`}
              onClick={async () => {
                const res = await disposeAsset(row.id, 0);
                toast.success(`${t("acct.assetDisposed")} ${res.entry_number}`);
                onDone();
              }}
            >
              {t("acct.dispose")}
            </NeuButton>
          </>
        ) : null}
      </div>
      {open ? (
        <div className="flex flex-wrap items-center gap-3 rounded-2xl p-3 shadow-neu-in">
          <p className="text-[11px] text-muted-foreground">{t("acct.ifrs.impairHint")}</p>
          <NeuInput
            type="number"
            className="w-40"
            data-testid={`impair-amount-${row.id}`}
            placeholder={t("acct.amount")}
            value={amount}
            onChange={(event) => setAmount(event.target.value)}
          />
          <NeuButton variant="primary" data-testid={`impair-save-${row.id}`} disabled={!amount} onClick={impair}>
            {t("app.save")}
          </NeuButton>
        </div>
      ) : null}
    </NeuCard>
  );
};
